import Box from "./Box";
import HeadingSmall from "./HeadingSmall";
import LargeHeadingImageSection from "./LargeHeadingImageSection";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TwoColBox from "./TwoColBox";

function AboutResale({
  image,
  mobImage,
  callout1,
  text1,
  callout2,
  text2,
  sectionId,
}) {
  return (
    <Box id={sectionId}>
      <LargeHeadingImageSection
        heading="Reskinned <b><i>Resale</i></b>"
        image={image}
        mobImage={mobImage}
        bg="white"
      >
        <TwoColBox
          col1={<HeadingSmall>{callout1}</HeadingSmall>}
          col2={<RichTextLarge>{text1}</RichTextLarge>}
        ></TwoColBox>
        <Box mt={[60, null, 100, null]}>
          <TwoColBox
            col1={<HeadingSmall>{callout2}</HeadingSmall>}
            col2={<RichTextLarge>{text2}</RichTextLarge>}
          ></TwoColBox>
        </Box>
      </LargeHeadingImageSection>
    </Box>
  );
}

export default AboutResale;

AboutResale.propTypes = {
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  mobImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
  callout1: PropTypes.string.isRequired,
  text1: PropTypes.string.isRequired,
  callout2: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
};
